<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(loadingSignatory){
      <app-skeleton-loader></app-skeleton-loader>
      }@else{ @if (step >= 1) {
        <!-- Action for show notes -->
        @if (srNumber && srInprgoressAwating && !loadingSignatory) {
          <app-validation-message
            type="info"
            [content]="{
              title: 'SECTION_NOTES' | translate,
              message: 'SECTION_NOTES_DESCRIPTION' | translate
            }"
            [showbutton]="false"
            [buttonText]="'VIEW_NOTES' | translate"
            (onBtnClick)="showNotes = true"
          />
        } 

      <section>
        <h1 class="section-heading">
          {{ "MANAGE_SIGNATORIES.TITLE" | translate }}
        </h1>
        <p>
          {{ "MANAGE_SIGNATORIES.DESCRIPTION" | translate }}
        </p>
        <div id="signatory-list-section">
          <app-card-carousel
          [ownerList]="ownerList"
          [showActions]="showActions"
          [memberLabelOwnerPartnerList]="memberLabelOwnerPartnerList"
          (onActionClick)="ownerViewRemove($event)"
          />
        </div>
        @if(showActions){
        <app-button
          [type]="'button'"
          [label]="'BUTTONS.ADD_NEW_SIGNATORY' | translate"
          classesName="btn-edge-cut mt-8 mb-8"
          (onBtnClick)="openAddOwnerModal()"
        />
        }
      </section>
      }
      <!-- @if (step >= 2) { -->
      @if(ownerList && ownerList.length > 0){
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "DOCUMENTS.TITLE" | translate }}
          </h1>
          <div class="fields-container">
            @if(loadingDoc){
                <app-skeleton-loader [formLoader]="true" [noOfFields]="3"></app-skeleton-loader>
              }
              @if (srFolder && !loadingDoc) {
                @for (dt of mainFromSectionDocs; track $index) {
                <div class="field-control">
                  <app-file
                    #fileCmp
                    [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                    [documentType]="dt.nameEn"
                    (folderMissing)="openFolder()"
                    (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                    [showAction]="showActions"
                    [folder]="srFolder"
                    [documentServiceType]="documentServiceType.MANAGE_SIG"
                  ></app-file>
                </div>
                }
              }
          </div>
        </section>
      }
      <!-- } -->
      <!----- SUBMIT actions --------->
      @if(noSignatoryChangesMsg){
      <div class="mb-5">
        <app-validation-message
          [content]="{
            title: 'ALERT.ERROR' | translate,
            message: 'ALERT.ADD_OR_MODIFY_SIGNATORY'
          }"
          type="error"
        />
      </div>
      }
      <!-- Error Message -->
      @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
      }
      @if (errorMsg) {
      <app-validation-message
        [type]="'error'"
        [showCloseIcon]="false"
        [content]="{
          title: 'ALERT.ERROR' | translate,
          message: errorMsg
        }"
      >
      </app-validation-message>
      }
      <div class="buttons-group">
        @if(showActions && !formSubmitLoader){
        <app-button
          type="button"
          classesName="btn-edge-cut  btn-width-auto"
          [label]="'BUTTONS.SUBMIT' | translate"
          (onBtnClick)="submit()"
        />
        } @if (formSubmitLoader) {
        <app-button
          type="button"
          classesName="btn-edge-cut btn-width-auto"
          [label]="'PLEASE_WAIT' | translate"
          [disabled]="true"
        ></app-button>
        }
      </div>
      }
    </div>
  </div>
  <!-- Form Completion Progress -->
  <div>
    <app-service-progress
      [serviceName]="'MEMBERSHIP_MANAGE_SIGNATORY' | translate"
      [completePercentage]="formProgress"
    />
  </div>
</div>

<!-- Add Owner/Manager Modal -->
@if (addOwnerModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="addOwnerModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "MANAGE_SIGNATORIES.ADD_SIGNATORY_TITLE" | translate }}
    </h1>
    <!-- content -->
    <app-add-signatory
      [(isOpen)]="addOwnerModal"
      (onBtnClick)="onOwnerSubmit($event)"
      [data]="selectedOwner"
      [allMembersData]="ownerList"
      [showAction]="signatoryModalEditable"
      [srFolder]="srFolder"
      [countryList]="countryLovList"
      (folderMissing)="openFolder()"
    />
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

@if (pendingSrNumber) {
<app-pending-sr-modal
  [srNumber]="pendingSrNumber"
  (onClose)="closependingSrModal()"
/>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes [srNumber]="srNumber" [allowSubmit]="true" (onClose)="showNotes = false;"></app-notes>
}
